import React from 'react';
import { motion } from 'framer-motion';
import { volumes } from '../data/content';
export function VolumesSection() {
  return <section className="w-full bg-navy px-5 py-10 sm:py-16" data-id="element-240" data-mp="3utcdx1k8g6px">
      <div className="mx-auto max-w-5xl" data-id="element-241" data-mp="co92z07l50hl">
        <div className="mx-auto max-w-2xl text-center" data-id="element-242" data-mp="cnzbf86w6l9s">
          <h2 className="font-display text-2xl font-bold leading-tight text-white sm:text-4xl" data-id="element-243" data-mp="7po4p6bw8qvs">
            6 Core Teaching Volumes for the Art Year
          </h2>
          <p className="mt-3 text-sm text-white/70 sm:text-base" data-id="element-244" data-mp="3g3557dk1222f">
            A connected sequence of visual resources that moves from foundational concepts to
            drawing, color, design, visual culture and independent creative work.
          </p>
        </div>
        <div className="mt-7 grid gap-4 sm:mt-9 sm:gap-6 md:grid-cols-2" data-id="element-245" data-mp="3l3j2q1o05tm7">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: index % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-4 rounded-2xl border border-gold/35 bg-navy-mid p-5 shadow-sm shadow-black/25 sm:gap-6 sm:p-7" data-id="element-246" data-mp="2xd5i2w7qyx1n" data-mpi={index}>
              <div className="flex min-w-0 flex-1 flex-col" data-id="element-247" data-mp="2o4ocgdc5tob2">
                <span className="font-display text-3xl font-bold leading-none text-gold sm:text-4xl" data-id="element-248" data-mp="1qgmjff5dllpv">
                  {volume.number}
                </span>
                <h3 className="mt-3 text-base font-bold leading-snug text-white sm:text-lg" data-id="element-249" data-mp="1vg98clukgqei">
                  {volume.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-white/70" data-id="element-250" data-mp="24gfetnrukq46">
                  {volume.description}
                </p>
                <span className="mt-5 inline-block w-fit rounded-full bg-gold/15 px-3 py-1 text-xs font-medium text-gold" data-id="element-251" data-mp="3bt7h8iw03iye">
                  {volume.tag}
                </span>
              </div>
              <div className="shrink-0 self-start rounded-xl bg-navy p-1.5 ring-1 ring-gold/30" data-id="element-252" data-mp="1gprisi4skxcz">
                <img src={volume.coverImage} alt={`Cover of volume ${volume.number}: ${volume.title}`} width="108" height="162" loading="lazy" decoding="async" className="block h-[132px] w-[88px] rounded-lg object-cover shadow-[0_8px_16px_-7px_rgba(0,0,0,0.65)] sm:h-[162px] sm:w-[108px]" data-id="element-253" data-mp="1bqoi19vuhdat" />
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}